'use client';
import { setToString } from './set.utils.js';
import { iterToSet } from './transform.utils.js';
import { ROOT_CLASSNAMES } from '../constants/globals.js';

function getRootClassNames({ standardMode: r = !1, darkMode: a = !1, compactMode: e = !1 } = {}, s = []) {
    let m = iterToSet(s);
    return m.add(ROOT_CLASSNAMES.base), r && m.add(ROOT_CLASSNAMES.standardMode), a && m.add(ROOT_CLASSNAMES.darkMode), e && m.add(ROOT_CLASSNAMES.compactMode), setToString(m);
}

export { getRootClassNames };
